import React from 'react';
import { ListFilter, type CheckboxSelectEntry } from '@atlassian/jira-filters';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { ProjectId, VersionId } from '@atlassian/jira-shared-types';
import { useFixVersionsFilter } from '../../../controllers/top-filter';
import { useFixVersions } from '../../../services/get-versions';
import messages from './messages';

// this component will be removed during ff cleanup - a11y-jira-team.deployment-filter-and-table_m845b
const VersionFilter = ({ projectId }: { projectId: ProjectId }) => {
	const { data, error, loading } = useFixVersions(projectId);

	if (error) {
		throw error;
	}

	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [selectedFixVersions, actions] = useFixVersionsFilter();

	const fixVersions = data
		? data.map((version) => ({
				value: version.name,
				label: version.name,
			}))
		: [];

	return (
		<ListFilter
			label={formatMessage(messages.versions)}
			values={fixVersions}
			selectedValues={selectedFixVersions}
			onChange={(newSelectedFixVersions: CheckboxSelectEntry[]) => {
				fireUIAnalytics(
					createAnalyticsEvent({
						action: 'toggled',
						actionSubject: 'deploymentsFixVersionsFilter',
					}),
				);
				actions.setFixVersionFilter(newSelectedFixVersions.map((v) => v.value));
			}}
			isLoading={loading}
			showMenuIfValuesAreEmpty={false}
		/>
	);
};

type Props = {
	projectId: ProjectId;
	isNested?: boolean;
	selectedValues: string[];
	onChange: (arg: VersionId[]) => void;
};

export const VersionFilterNew = ({ projectId, isNested, selectedValues, onChange }: Props) => {
	const { data, error, loading } = useFixVersions(projectId);

	if (error) {
		throw error;
	}

	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fixVersions = data
		? data.map((version) => ({
				value: version.name,
				label: version.name,
			}))
		: [];

	return (
		<ListFilter
			label={formatMessage(messages.versions)}
			values={fixVersions}
			selectedValues={selectedValues}
			onChange={(newSelectedFixVersions: CheckboxSelectEntry[]) => {
				fireUIAnalytics(
					createAnalyticsEvent({
						action: 'toggled',
						actionSubject: 'deploymentsFixVersionsFilter',
					}),
				);
				onChange(newSelectedFixVersions.map((v) => v.value));
			}}
			isLoading={loading}
			showMenuIfValuesAreEmpty={false}
			isNested={isNested}
		/>
	);
};

export default VersionFilter;
